// extracted by css-extract-rspack-plugin
export default {"cls1":"PdfMiniChip-cls1_QW0","cls2":"PdfMiniChip-cls2_h7Y PdfMiniChip-cls1_QW0","size-row":"PdfMiniChip-size-row_bnm","size-modalcard":"PdfMiniChip-size-modalcard_6I3"};